module.exports = __webpack_public_path__ + "static/media/aryo_nuugraha.83eb65a3.jpg";